import {QUERY_KEYS} from '@/queryClient'
import {useInfiniteQuery, UseInfiniteQueryOptions} from '@tanstack/react-query'
import {
    httpGetUsersByPatient,
    HttpGetUsersByPatientOptions,
    HttpGetUsersByPatientResponse
} from '@/features/users/http/users.http'

export const useGetUsersByPatient = (
    params: HttpGetUsersByPatientOptions['params'],
    options?: Pick<UseInfiniteQueryOptions<HttpGetUsersByPatientResponse>, 'enabled'>
) =>
    useInfiniteQuery({
        queryKey: [QUERY_KEYS.USERS_BY_PATIENT, params],
        queryFn: ({pageParam = 1}) => httpGetUsersByPatient({params: {...params, page: pageParam}}),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })
